import { render, staticRenderFns } from "./ConvertPositionToTemplateDialog.vue?vue&type=template&id=350ac981&"
import script from "./ConvertPositionToTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./ConvertPositionToTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports